import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RemoteService } from 'app/services/remote.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-complete-restore',
  templateUrl: './complete-restore.component.html',
  styleUrls: ['./complete-restore.component.scss']
})
export class CompleteRestoreComponent implements OnInit {
  varificationFailed: boolean;
  varificationProcessing: boolean = true;
  varificationSuccess: boolean;
  alreadyVeryfied: boolean;
  constructor(private router: Router,
    private remoteService: RemoteService,
    private route: ActivatedRoute,
    private notifierService: NotifierService) { }

  ngOnInit() {
    this.queryParam();
  }

  queryParam() {
    this.route
      .queryParams
      .subscribe(params => {
        if (params.jwtToken) {
          this.verificationSignUp(params.jwtToken);
        } else {
          this.router.navigate(['/login']);
        }
      });
  }

  verificationSignUp(token) {
    this.remoteService.verifyRestoreAccount(token).subscribe(res => {
      if (res === true) {
        this.varificationProcessing = false;
        this.varificationSuccess = true;
      } else {
        this.remoteService.hideSpinner();
        this.varificationProcessing = false;
        this.alreadyVeryfied = true;
        this.varificationSuccess = false;
      }
    }, (error) => {
      this.varificationProcessing = false;
      this.alreadyVeryfied = false;
      this.varificationSuccess = false;
      this.varificationFailed = true;
      this.remoteService.hideSpinner();
    })
  }
}
